module.exports = __webpack_public_path__ + "img/cert8.db146c9f.png";